import './bootstrap';
import '../css/app.css';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';
import * as Sentry from '@sentry/vue';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) });

        Sentry.init({
            app,
            dsn: "https://3f213e51daf5b9f17e15feb8da1149fe@o346689.ingest.us.sentry.io/4506917998493696",
            integrations: [],
            tracesSampleRate: 0.1,
        });

        app.use(plugin)
        .use(ZiggyVue)
        .mount(el);

        return app;
    },
    progress: {
        color: '#0ca498',
    },
});
